import React, { useMemo } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Tooltip } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { ColumnDirective, ColumnsDirective, GridComponent, Filter, Group } from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search } from '@syncfusion/ej2-react-grids';
import useWeighbridgeData from './useWeighbridgeData';
import { LoadScript } from '@react-google-maps/api';
import WeighbridgeMap from './WeighbridgeMap';
import AddEditWeighbridgeModal from './AddEditWeighbridgeModal';
import MapIcon from '@mui/icons-material/Map';
import EditIcon from '@mui/icons-material/Edit';
import ScaleIcon from '@mui/icons-material/Scale';

const ManageWeighbridge = () => {
  const history = useHistory();
  const {
    weighbridgeDetails,
    destinationList,
    openMapModal,
    closeMapModal,
    showMap,
    mapData,
    showModal,
    editData,
    openAddModal,
    openEditModal,
    closeModal,
    saveWeighbridge,
  } = useWeighbridgeData();

  const pageSettings = useMemo(
    () => ({
      pageSize: 30,
      pageSizes: [5, 10, 20, 30, 40],
    }),
    [],
  );

  const filterSettings = { type: 'Excel' };

  const toolbarOptions = ['Search'];

  const mapTemplate = row => (
    <Tooltip title="View on Map">
      <IconButton size="small" color="primary" onClick={() => openMapModal(row)}>
        <MapIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );

  const actionTemplate = row => (
    <Stack direction="row" spacing={1} justifyContent="center">
      <Tooltip title="Edit Customer / Weighbridge">
        <Button size="small" variant="outlined" color={'primary'} onClick={() => openEditModal(row)}>
          <EditIcon sx={{ fontSize: 16, mr: 1 }} /> Edit
        </Button>
      </Tooltip>
    </Stack>
  );

  return (
    <div className="app-wrapper">
      <style>
        {`
          .e-grid .e-selectionbackground {
            background-color: #D6EAF8 !important; /* highlight color */
          }
        `}
      </style>

      <Box display="flex" justifyContent="space-between" mb={2}>
        <h2>Manage Weighbridge</h2>
        <Box display="flex" gap={2}>
          <Button variant="contained" onClick={openAddModal}>
            Add Customer / Weighbridge
          </Button>
          <Button variant="contained" onClick={() => history.push('/')}>
            Home
          </Button>
        </Box>
      </Box>

      <GridComponent
        dataSource={weighbridgeDetails}
        filterSettings={filterSettings}
        allowPaging
        allowSorting
        allowFiltering
        allowResizing
        allowReordering
        allowTextWrap
        pageSettings={pageSettings}
        toolbar={toolbarOptions}
        height="500px">
        <ColumnsDirective>
          <ColumnDirective
            field="destinationSiteAssessmentID"
            headerText="Destination Assessment ID"
            width="130"
            clipMode="EllipsisWithTooltip"
          />

          <ColumnDirective field="destinationName" headerText="Destination Name" width="160" />

          <ColumnDirective
            field="customerName"
            headerText="Customer Name"
            validationRules={{ required: true }}
            width="160"
          />

          <ColumnDirective field="custCode" headerText="Cust Code" width="120" textAlign="Center" />

          <ColumnDirective
            field="weighbridgeName"
            headerText="Weighbridge Name"
            validationRules={{ required: true }}
            width="180"
          />

          <ColumnDirective
            field="adminEmailAddress"
            headerText="Admin Email Address"
            validationRules={{ required: true }}
            width="180"
          />

          <ColumnDirective
            field="accountsEmailAddress"
            headerText="Accounts Email Address"
            validationRules={{ required: true }}
            width="180"
          />

          <ColumnDirective headerText="View on Map" template={mapTemplate} width="80" textAlign="Center" />
          <ColumnDirective headerText="Action" template={actionTemplate} width="100" textAlign="Center" />
        </ColumnsDirective>

        <Inject services={[Page, Sort, Filter, Group, Search]} />
      </GridComponent>

      {/* ADD MODAL */}
      <AddEditWeighbridgeModal
        open={showModal}
        onClose={closeModal}
        destinationList={destinationList}
        onSave={saveWeighbridge}
        editData={editData}
      />

      {/* MAP MODAL */}
      <Dialog open={showMap} onClose={closeMapModal} maxWidth="lg" fullWidth>
        <DialogTitle>Destination</DialogTitle>
        <DialogContent sx={{ height: '70vh', padding: 0 }}>
          <LoadScript googleMapsApiKey="AIzaSyA94J1dEXShLTlOZmIZbmOT31Qyo2g-2OU">
            <WeighbridgeMap mapData={mapData} show={showMap} />
          </LoadScript>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ManageWeighbridge;
